import moment from "moment";

export default class DateUtils {

    static dateFormatter(date, format = "ddd MMM DD YYYY") {

        if (date) {
            return moment(date).format(format);
        } else {
            return "N/A"
        }
    }

    static dateSubtractor(unit, type) {
        return moment().subtract(unit, type)
    }

    static dateAddition(unit, type, date) {
        if(date) {
            return moment(date).add(unit, type)
        }
        return moment().add(unit, type)
    }
    /**
     * Determines if the provided date is in the past relative to the current date and time.
     * 
     * @param {string|Object} date - The date to be checked. This can be a string in a recognized 
     *                               moment.js format, a JavaScript Date object, or a moment.js date object.
     * 
     * @returns {boolean} True if the provided date is in the past; false otherwise.
     * 
     * @throws Will throw an error if the provided date is not in a recognized format.
     */
    static isPastDate(date) {
        return moment().isBefore(date);
    }


    /**
     * Retrieves the start of the specified time unit (e.g., day, week, month, etc.) using moment.js.
     *
     * @param {string} [string="day"] - The time unit for which the start is to be calculated. Default is 'day'.
     *                                  Accepted values are 'year', 'quarter', 'month', 'week', 'isoWeek', 'day',
     *                                  'hour', 'minute', 'second', and 'millisecond'.
     * 
     * @returns A moment.js object set to the start of the specified time unit.
     * 
     */
    static getStartOf(string = "day") {
        return moment().startOf(string);
    }

    static getEndOf(string = "day", date) {
        if(date) {
            return moment(date).endOf(string);
        }
        return moment().startOf(string);
    }



    static getMomentDate(dateStr, format = 'MM/DD/YYYY') {
        return moment(dateStr, format)
    }

    static getMomentObject(dateStr, format = "MM/DD/YYYY") {
        return moment(dateStr, format).toDate()
    }

}